import template from './user_select.html';

angular.module('bb.users').directive('bbUserMultiSelect', () => ({
  restrict: 'E',
  scope: {
    userIds: '=',
    maxUsers: '=?',
    canSelectAll: '=?',
  },
  controller: UserMultiSelectController,
  bindToController: true,
  controllerAs: 'vm',
  template,
}));

UserMultiSelectController.$inject = ['userService', '$scope'];
function UserMultiSelectController(userService, $scope) {
  const vm = this;
  this.$onInit = () => {
    vm._selectedUsers = [];
    vm.users = [];

    vm.selectOptions = {
      enableSearch: true,
      scrollable: true,
      showCheckAll: false,
      showUncheckAll: true,
      closeOnSelect: vm.maxUsers == 1,
      clearSearchOnClose: true,
      smartButtonMaxItems: 1,
      smartButtonTextConverter(itemText) {
        return itemText;
      },
      template: `
          <span ng-class="{'important': option.id === 'ALL'}"
            data-cy="{{option.id}}">
            {{option.label}}
          </span>
        `,
    };

    if (vm.maxUsers) {
      vm.selectOptions.selectionLimit = vm.maxUsers;
    }
    vm.init();
  };

  $scope.$watch(
    'vm.userIds',
    (newValue, oldValue) => {
      if (newValue.join(',') === oldValue.join(',')) return;
      vm.init();
    },
    true,
  );

  function updateUserIds() {
    vm.userIds = vm._selectedUsers.map(user => user.id);
  }

  function onDeselectAll() {
    vm.userIds = [];
  }

  vm.multiselectEvents = {
    onItemSelect: updateUserIds,
    onItemDeselect: updateUserIds,
    onSelectAll: updateUserIds,
    onDeselectAll,
  };

  vm.init = () => {
    // TODO: Refactor this fetch up to the page and pass it into the component instead
    userService.getBasicUsers().then(users => {
      vm.users = users;
      if (vm.canSelectAll)
        vm.users.unshift({
          id: 'ALL',
          label: 'SEARCH ENTIRE BROKERAGE',
        });
      vm.userIndexById = {};

      vm.users.forEach((user, i) => {
        vm.userIndexById[user.id] = i;
      });
      vm._selectedUsers = vm.userIds
        .map(id => {
          const i = vm.userIndexById[id];
          return vm.users[i];
        })
        // filter invalid Ids
        .filter(user => user);
    });
  };
}
